import { useEffect, useState } from 'react';

import {
	consoleDev,
	ConsoleStatus,
	fetchData,
	validateInput,
} from '@quizzach/utils';
import {
	RegistrationState,
	RoutePath,
	registrationFields,
} from '@quizzach/interfaces';
import { useNavigate } from 'react-router';

export const useRegistration = () => {
	const [registrationState, setRegistrationState] = useState<RegistrationState>(
		new RegistrationState()
	);
	const [validationErrorStates, setValidationErrorStates] =
		useState<RegistrationState>(new RegistrationState());
	const [error, setError] = useState<boolean>(false);
	const [errorCode, setErrorCode] = useState<string>();
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [showPassword, setShowPassword] = useState<boolean>(false);
	const [registrationDisable, setRegistrationDisable] =
		useState<boolean>(false);

	const [buttonClicked, setButtonClicked] = useState<boolean>(false);
	const navigate = useNavigate();

	const register = async () => {
		try {
			setIsLoading(true);
			const response = await fetchData<any>(`/api/register`, {
				method: 'POST',
				body: JSON.stringify(registrationState),
			});
			if (response.status >= 300) {
				consoleDev('register', ConsoleStatus.HTTP, response.status);

				setError(true);
				const errorMessage = response?.violations?.[0]?.message;
				setErrorCode(errorMessage);
			} else {
				consoleDev('register', ConsoleStatus.SUCC);
				navigate(RoutePath.RegistrationSuccess);
			}
		} catch (err) {
			consoleDev('register', ConsoleStatus.NET, err);
			setError(true);
		} finally {
			setIsLoading(false);
		}
	};

	const handleInputChange = (name: string, value: string): void => {
		setRegistrationState((prevProps) => ({
			...prevProps,
			[name]: value,
		}));

		setValidationErrorStates((prevErrors) => ({
			...prevErrors,
			[name]: validateInput(name, value),
		}));
	};

	const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
		event.preventDefault();
		setButtonClicked(true);

		if (
			registrationFields.every(({ identifier }) => {
				return (
					validationErrorStates[identifier as keyof RegistrationState] === ''
				);
			})
		) {
			register().catch(() => {
				setError(true);
			});
		}
	};

	const togglePasswordVisibility = (): void => {
		setShowPassword(!showPassword);
	};

	useEffect(() => {
		setRegistrationDisable(
			registrationFields.every(({ identifier }) => {
				return registrationState[identifier as keyof RegistrationState] !== '';
			})
		);
	}, [registrationState]);

	return {
		registrationState,
		registrationDisable,
		validationErrorStates,
		error,
		errorCode,
		isLoading,
		showPassword,
		buttonClicked,
		handleInputChange,
		handleSubmit,
		togglePasswordVisibility,
	};
};
